import { theme } from "Theme"
import styled from "styled-components"

const Gap = styled.div`
  padding: 1rem;
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
    padding: 2rem;
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
`

export default Gap
